// extracted by mini-css-extract-plugin
export default {"collapse":"styles_collapse__6T6mN"};